import { render, staticRenderFns } from "./_Customer.vue?vue&type=template&id=5cf25ab4&"
import script from "./_Customer.vue?vue&type=script&lang=js&"
export * from "./_Customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports